<div class="auth-page-wrapper pt-5">
  <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
    <div class="bg-overlay"></div>
    <div class="shape">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 120">
        <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
      </svg>
    </div>
  </div>
  <div class="auth-page-content">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center pt-4">
            <div class="">
              <img src="assets/images/svg/error.svg" alt="" class="error-basic-img move-animation">
            </div>
            <div class="mt-n4">
              <h1 class="display-1 fw-medium">404</h1>
              <h3 class="text-uppercase">Sorry, Page not Found 😭</h3>
              <p class="text-muted mb-4">The page you are looking for not available!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer class="footer">
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-6">
					{{year}} © Revealense. Illuminate the hidden
					</div>
				<div class="col-sm-6">
					<div class="text-sm-end d-none d-sm-block">
						<a href="https://lordicon.com/">Animated icons by Lordicon.com</a>
					</div>
				</div>
			</div>
		</div>
	</footer>
</div>